<script setup lang="ts">
import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { defineProps, inject, ref, defineModel, watch } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  matrix: DestinyMatrix | undefined;
  hasPremiumAccess: boolean;
}>();
const isOpen = defineModel<boolean>({ default: false });
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (description.value = undefined)
);

const description = ref();

async function getData() {
  if (!props.hasPremiumAccess) {
    isOpen.value = false;
  }
  if (!description.value && props.matrix && getDescription) {
    description.value = await getDescription(
      DestinyMatrixKeysEnum.PREDISPOSITION_TO_DISEASES
    );
  }
}
</script>

<template>
  <AccordionComponent
    type="white"
    @opened="getData"
    v-model="isOpen"
    :isBlocked="!hasPremiumAccess"
  >
    <template #title>
      {{
        t("calculators.destiny-matrix.accordions.predisposition-to-diseases")
      }}
    </template>
    <template #faq-content>
      <div v-if="description" class="flex flex-col gap-4 sf-pro">
        <p class="text-xl font-bold pt-4 mb-2">
          {{ description["titles"]["heritage_diseases"] }}
        </p>
        <!-- PARENTS LINES DISEASES -->
        <p class="text-lg font-bold my-1">
          {{ description["titles"]["father_line_diseases"] }}
        </p>
        <div class="whitespace-pre-line">
          {{ description["parents_diseases"]["male_line"] }}
        </div>
        <p class="text-lg font-bold my-1">
          {{ description["titles"]["mather_line_diseases"] }}
        </p>
        <div class="whitespace-pre-line">
          {{ description["parents_diseases"]["female_line"] }}
        </div>
        <!-- ENERGY DISEASES -->
        <p class="text-xl font-bold pt-4 mb-2">
          {{ description["titles"]["minuses_diseases"] }}
        </p>
        <div v-for="(disease, index) in description['diseases']" :key="index">
          <p class="text-lg font-bold my-1">
            {{ description["titles"]["what_personality_trigger_diseases"] }}
          </p>
          <div class="whitespace-pre-line">
            {{ disease }}
          </div>
        </div>
      </div>
    </template>
    <template #collapse-text-btn>
      {{ t("calculators.destiny-matrix.accordions.collapse") }}
    </template>
  </AccordionComponent>
</template>
